const modal = {
  helper: 'Vous pourrez éditer ce fichier en revenant sur le formulaire'
};

export default modal;
